import { Template } from "../../Components/Template/template"
import { classDivBackground, classDivBody } from "../../Utils/Types"

export const SaidaNotaPage = () => {

    return (
        <Template>

            <div className={`${classDivBackground}`}>

                <div id='div-body' className={`${classDivBody}`}>

                   

                </div>


            </div>

        </Template>
    )

}